var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.382 0a1 1 0 0 1 .894.553L16 4v11a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V4L1.724.553A1 1 0 0 1 2.618 0h10.764ZM8 6c-.55 0-1 .45-1 1v2.59l-.29-.29-.081-.076A.97.97 0 0 0 6 9a1.003 1.003 0 0 0-.71 1.71l2 2 .096.084c.168.13.38.206.614.206.28 0 .53-.11.71-.29l2-2 .084-.096A1.003 1.003 0 0 0 9.29 9.29l-.29.3V7l-.007-.116A1.004 1.004 0 0 0 8 6Zm5-4H3L2 4h12l-1-2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.4765f6a33457a435f53210f7b2200739.svg";
export { ForwardRef as ReactComponent };